export enum CustomerRiskAndCoverageTabTypes {
    INSURANCE = 'insurance',
    COMPLIANCE = 'compliance',
    CREDIT_BUREAU = 'credit_bureau'
}
